/* ═══════════════════════════════════════════════════════════════════════
   NP CLASSIC OPTIONS — the theme-native replacement for the BCPO app
   ═══════════════════════════════════════════════════════════════════════
   Renders the classic order form's variant options (shape, corner style,
   colors, border style, backing, …) from window.NP_CLASSIC_OPTIONS
   (np-classic-options-data.js — generated 1:1 from the live app configs for
   all 59 products) and writes the EXACT same line-item property names and
   values the app wrote, trailing spaces included ("Border Thread Color ").

   WHERE IT RUNS
   - Pages with the 2.0 builder (#np-e2 present): classic mode only — it
     mounts when body.np-e2-classic appears and stays out of the AI flow.
   - Legacy product pages without the builder (the SEO alias handles):
     always, exactly where the app used to sit.

   The BCPO app UI is suppressed by CSS below; once this is verified the app
   can be uninstalled — nothing here depends on it.                       */
(function () {
  'use strict';
  var DATA = window.NP_CLASSIC_OPTIONS;
  var HANDLE = window.NP_CLASSIC_HANDLE || '';
  if (!DATA || !HANDLE) return;
  var archIdx = DATA.byHandle[HANDLE];
  if (archIdx === undefined) return; /* this product never had app options */
  /* 2026-09-10: the theme's native option-1 group is hidden in Liquid only for the byHandle list; hide it here too so an
     aliased / newly added handle never shows both the native Size radios and these classic rows */
  try { document.querySelectorAll('.product-variant[option="1"]').forEach(function (el) { el.style.display = 'none'; }); } catch (eH1) {}
  var OPTS = DATA.archetypes[archIdx];
  if (!OPTS || !OPTS.length) return;
  /* normalize vals to {k, i} objects (older data carried plain strings) */
  OPTS.forEach(function (oN) {
    oN.vals = (oN.vals || []).map(function (v) { return typeof v === 'string' ? { k: v } : v; });
  });
  /* MERGE per-shape duplicates (old BCPO admin modeling): "Border Style
     Circle/Square/…" (suffix form) and "Rectangle/Square Corner Style"
     (prefix form) collapse into ONE row whose label drops the shape and
     whose values AND line-item property name follow the selected shape —
     the emitted properties stay byte-identical to the app's. */
  var RENDER = [];
  (function buildMerge() {
    var groups = {};
    OPTS.forEach(function (o) {
      if (!o.condT || !o.condV) { RENDER.push(o); return; }
      var t = o.t.replace(/\s+$/, ''), base = '';
      var sfx = ' ' + o.condV, pfx = o.condV + ' ';
      if (t.length > sfx.length && t.slice(-sfx.length) === sfx) base = t.slice(0, -sfx.length);
      else if (t.indexOf(pfx) === 0 && t.length > pfx.length) base = t.slice(pfx.length);
      if (!base) { RENDER.push(o); return; }
      var gk = o.condT + '||' + base + '||' + o.k;
      if (!groups[gk]) {
        groups[gk] = { merged: true, base: base, condT: o.condT, k: o.k, ta: false, req: o.req, subs: {} };
        RENDER.push(groups[gk]);
      }
      groups[gk].subs[o.condV] = o;
    });
    RENDER = RENDER.map(function (r) {
      if (!r.merged) return r;
      var ks = Object.keys(r.subs);
      return ks.length > 1 ? r : r.subs[ks[0]]; /* a group of one is just a conditional row */
    });
  })();
  function activeSub(r) { return r.merged ? (r.subs[state[r.condT] || ''] || null) : r; }

  var css = [
    /* the app's own widget never shows again — this widget owns the options */
    '#bcpo, .bcpo-cart-widget, .selector-wrapper.bcpo-simple { display: none !important; }',
    '#np-co { display: flex !important; }',
    '.np-co__row[hidden] { display: none !important; }',
    '.np-co { margin: 14px 0 18px; display: flex; flex-direction: column; gap: 20px; }',
    '.np-co__row .np-e2-lnc--follow { align-self: flex-start; width: auto; background: #1AA86C !important;' +
      ' color: #fff !important; border-color: #1AA86C !important; box-shadow: none !important; }',
    '.np-co__row .np-e2-lnc--follow.is-on { background: #0E7A4C !important; box-shadow: 0 0 0 3px rgba(26,168,108,.25) !important; }',
    '.np-co__row .np-e2-lnc--follow .np-e2-ftip svg { stroke: #fff; }',
    /* the size widget + Patch Size strip read as ONE white card — pure CSS,
       no DOM restructuring (a wrapper div broke the legacy size widget) */
    '.shopify-section[id$="__main"] sizes-blocks { display: block; background: #fff; border: 1px solid #E9EDF1;' +
      ' border-bottom: 0; border-radius: 14px 14px 0 0; box-shadow: 0 2px 12px rgba(15,23,42,.07); padding: 16px 16px 4px; }',
    '.shopify-section[id$="__main"] .customVariantWidget-2 { background: #fff; border: 1px solid #E9EDF1;' +
      ' border-top: 0; border-radius: 0 0 14px 14px; box-shadow: 0 2px 12px rgba(15,23,42,.07);' +
      ' padding: 0 16px 14px; margin: 0 0 20px; }',
    '@media (max-width: 767px) { .shopify-section[id$="__main"] sizes-blocks,' +
      ' .shopify-section[id$="__main"] .customVariantWidget,' +
      ' .shopify-section[id$="__main"] .customVariantWidget-2 {' +
      ' max-width: 100% !important; width: auto !important; box-sizing: border-box; overflow-x: hidden; } }',
    '.np-co__row { display: flex; flex-direction: column; gap: 10px; background: #fff; border: 1px solid #E9EDF1;' +
      ' border-radius: 14px; box-shadow: 0 2px 12px rgba(15,23,42,.07); padding: 16px 16px 18px; }',
    '.np-co__lab { font-size: 13px; font-weight: 800; letter-spacing: .04em; text-transform: uppercase; color: #3d4642; }',
    '.np-co__lab .np-co__req { color: #B42318; font-weight: 700; margin-left: 3px; }',
    '.np-co__pills { display: flex; flex-wrap: wrap; gap: 8px; }',
    '.np-co__pill { border: 1.5px solid #CDD4DA; border-radius: 10px; background: #fff; padding: 10px 16px;' +
      ' font-family: inherit; font-size: 14px; font-weight: 600; color: #131715; cursor: pointer;' +
      ' transition: border-color .12s ease, background .12s ease; }',
    '.np-co__pill:hover { border-color: #1AA86C; }',
    '.np-co__pill.is-on { border-color: #1AA86C; background: #F3FAF6; font-weight: 700; }',
    '.np-co__txt { border: 1.5px solid #CDD4DA; border-radius: 10px; background: #fff; padding: 11px 13px;' +
      ' font-family: inherit; font-size: 14.5px; color: #131715; width: 100%; max-width: 460px; box-sizing: border-box; }',
    '.np-co__txt:focus { outline: none; border-color: #1AA86C; box-shadow: 0 0 0 3px rgba(26,168,108,.14); }',
    'textarea.np-co__txt { min-height: 74px; max-width: none; }',
    '.np-co__row.is-missing .np-co__lab { color: #B42318; }',
    '.np-co__row.is-missing .np-co__pill, .np-co__row.is-missing .np-co__txt { border-color: #E5A9A3; }',
    '.np-co__err { display: none; font-size: 13px; font-weight: 600; color: #B42318; }',
    '.np-co__row.is-missing .np-co__err { display: block; }',
    '.np-co__subhead { font-size: 13px; font-weight: 800; letter-spacing: .06em; color: #131715; margin: 6px 0 2px; }',
    '.np-co__sw { display: flex; flex-wrap: wrap; gap: 8px; }',
    '.np-co__swatch { display: flex; flex-direction: column; align-items: center; gap: 4px; width: 62px;' +
      ' border: 1.5px solid transparent; border-radius: 10px; background: transparent; padding: 6px 2px 5px;' +
      ' font-family: inherit; cursor: pointer; }',
    '.np-co__swatch i { display: block; width: 34px; height: 34px; border-radius: 9px; border: 1px solid rgba(12,12,14,.14); }',
    '.np-co__swatch b { font-size: 10.5px; font-weight: 600; color: #3d4642; line-height: 1.15; text-align: center;' +
      ' max-width: 62px; white-space: normal; word-break: keep-all; }',
    '.np-co__swatch:hover { border-color: #CDD4DA; }',
    '.np-co__swatch.is-on { border-color: #1AA86C; background: #F3FAF6; }',
    '.np-co__swatch.is-on b { font-weight: 800; color: #0E5C3C; }',
    '.np-co__swatch--wheel { position: relative; overflow: hidden; }',
    '.np-co__swatch--wheel i { background: conic-gradient(red, yellow, lime, cyan, blue, magenta, red); }',
    '.np-co__swatch--wheel input { position: absolute; inset: 0; opacity: 0; cursor: pointer; }',
    '.np-co__tiles { display: flex; flex-wrap: wrap; gap: 10px; }',
    /* shape tiles always share ONE row — equal widths, shrink as needed */
    '.np-co__tiles--shape { flex-wrap: nowrap; }',
    '.np-co__tiles--shape .np-co__tile { flex: 1 1 0; min-width: 0; max-width: 160px; width: auto; }',
    '.np-co__tiles--shape .np-co__tile img { width: 65%; max-width: 98px; height: auto; aspect-ratio: 1 / 1; }',
    /* mobile: shapes wrap into two rows (3 + 2) so captions never break */
    '@media (max-width: 700px) {',
    '  .np-co__tiles--shape { flex-wrap: wrap; justify-content: center; }',
    '  .np-co__tiles--shape .np-co__tile { flex: 0 0 calc((100% - 20px) / 3); max-width: none; }',
    '}',
    '.np-co__tile { position: relative; display: flex; flex-direction: column; align-items: center; width: 150px;' +
      ' border: 1.5px solid #CDD4DA; border-radius: 12px; background: #fff; padding: 0; overflow: hidden;' +
      ' font-family: inherit; cursor: pointer; transition: border-color .12s ease, background .12s ease; }',
    '.np-co__tile img { width: 98px; height: 98px; object-fit: contain; border-radius: 8px; margin: 12px 12px 8px; }',
    /* the caption is a black bar across the tile bottom — white text pops */
    '.np-co__tile b { display: block; width: 100%; margin-top: auto; background: #131715; color: #fff;' +
      ' font-size: 12px; font-weight: 700; line-height: 1.3; text-align: center; padding: 8px 7px; box-sizing: border-box; }',
    '.np-co__tile:hover { border-color: #1AA86C; }',
    '.np-co__tile.is-on { border-color: #1AA86C; background: #F3FAF6; }',
    '.np-co__row.is-missing .np-co__tile { border-color: #E5A9A3; }',
    /* selection = green CHECKMARK, not just an outline */
    '.np-co__tile.is-on::after, .np-co__swatch.is-on::after { content: "\u2713"; position: absolute; top: 5px; right: 5px;' +
      ' width: 20px; height: 20px; border-radius: 50%; background: #1AA86C; color: #fff; font-size: 12px; font-weight: 800;' +
      ' display: flex; align-items: center; justify-content: center; box-shadow: 0 1px 3px rgba(0,0,0,.25); z-index: 2; }',
    '.np-co__swatch { position: relative; }',
    '.np-co__pill.is-on::before { content: "\u2713 "; color: #1AA86C; font-weight: 800; margin-right: 4px; }',
    /* "(Most Popular)" leaves the caption and becomes a corner flag */
    '.np-co__flag { position: absolute; top: 5px; left: 5px; background: #1AA86C; color: #fff; font-size: 9px;' +
      ' font-weight: 800; letter-spacing: .05em; text-transform: uppercase; padding: 3px 7px; border-radius: 5px;' +
      ' box-shadow: 0 1px 3px rgba(0,0,0,.2); z-index: 2; pointer-events: none; }',
    '.np-co__more i { display: flex; align-items: center; justify-content: center; border-style: dashed;' +
      ' background: #fff; font-style: normal; font-weight: 800; font-size: 16px; color: #3d4642; }'
  ].join('\n');
  var styleEl = document.createElement('style');
  styleEl.textContent = css;
  document.head.appendChild(styleEl);

  var COLORS = window.NP_CLASSIC_COLORS || [];
  /* C180: name custom wheel picks from the full PANTONE Solid Coated table the AI builder emits (#np-e2-config.pms),
     falling back to the short classic list; CIELAB ΔE76 nearest match (the old weighted-RGB matcher named tans "7565 C" orange) */
  var PMS = window.NP_CLASSIC_PMS || [];
  try {
    var cfgEl = document.getElementById('np-e2-config');
    var cfgPms = cfgEl ? (JSON.parse(cfgEl.textContent || '{}').pms || []) : [];
    if (cfgPms.length >= 500) PMS = cfgPms;
  } catch (e) {}
  function hexToLab(hex) {
    var h = (hex || '').replace('#', '');
    if (h.length !== 6) return null;
    var c = [parseInt(h.substr(0, 2), 16), parseInt(h.substr(2, 2), 16), parseInt(h.substr(4, 2), 16)];
    if (isNaN(c[0]) || isNaN(c[1]) || isNaN(c[2])) return null;
    var lin = c.map(function (v) { v /= 255; return v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); });
    var x = (lin[0] * 0.4124 + lin[1] * 0.3576 + lin[2] * 0.1805) / 0.95047;
    var y = (lin[0] * 0.2126 + lin[1] * 0.7152 + lin[2] * 0.0722) / 1.00000;
    var z = (lin[0] * 0.0193 + lin[1] * 0.1192 + lin[2] * 0.9505) / 1.08883;
    var f = function (t) { return t > 0.008856 ? Math.cbrt(t) : 7.787 * t + 16 / 116; };
    var fx = f(x), fy = f(y), fz = f(z);
    return [116 * fy - 16, 500 * (fx - fy), 200 * (fy - fz)];
  }
  var pmsLabCache = null;
  function pmsName(hex) {
    var lab = hexToLab(hex);
    if (!lab) return hex;
    if (!pmsLabCache || pmsLabCache.length !== PMS.length) pmsLabCache = PMS.map(function (row) { return hexToLab(row[0]); });
    var chroma = Math.sqrt(lab[1] * lab[1] + lab[2] * lab[2]);
    var inNeutral = chroma < 8;
    var isWhite = inNeutral && lab[0] > 93;
    var best = hex, bd = Infinity;
    for (var i = 0; i < PMS.length; i++) {
      var pl = pmsLabCache[i];
      if (!pl) continue;
      var pc = Math.sqrt(pl[1] * pl[1] + pl[2] * pl[2]);
      if ((pc < 8) !== inNeutral) continue;
      if (PMS[i][1] === 'White' && !isWhite) continue;
      var d = (lab[0] - pl[0]) * (lab[0] - pl[0]) + (lab[1] - pl[1]) * (lab[1] - pl[1]) + (lab[2] - pl[2]) * (lab[2] - pl[2]);
      if (d < bd) { bd = d; best = PMS[i][1]; }
    }
    return best;
  }
  /* C491 (Justin 2026-10-12: "fix classic mode to match ai mode … the hex … should be the correct one that matches pms and
     make sure the color swatch matches … accuracy is the most important part"): a PMS-named colour goes on the order as
     "PMS 289 C (#002340)" — the name AND Pantone's own Solid Coated hex for it (the same table the swatches are named from),
     and its swatch shows that colour. Plain names (White, Navy …) stay plain, as in AI mode. */
  var PMS_BARE = ['Black 6 C', 'Black C', 'Cool Gray 9 C', 'Cool Gray 6 C', 'Cool Gray 2 C', 'Cool Gray 1 C'];
  var pmsHexMap = null;
  function pmsHexOf(label) {
    if (!pmsHexMap || pmsHexMap.n !== PMS.length) { pmsHexMap = { n: PMS.length, m: {} }; PMS.forEach(function (row) { if (row && row[1] && !pmsHexMap.m[row[1]]) pmsHexMap.m[row[1]] = String(row[0] || '').toUpperCase(); }); }
    var h = pmsHexMap.m[label];
    return h && /^#[0-9A-F]{6}$/.test(h) ? h : null;
  }
  function isPmsLabel(label) { return /^PMS\s/.test(label || '') || PMS_BARE.indexOf(label) !== -1; }
  function withPmsHex(label) {
    if (!isPmsLabel(label) || /\(#[0-9a-f]{6}\)/i.test(label)) return label;
    var h = pmsHexOf(label);
    return h ? label + ' (' + h + ')' : label;
  }
  function isColorRow(o) { return !!o && o.k === 'text' && !o.ta && /color/i.test(o.t || ''); }
  /* C471 (Justin 2026-10-12: "on classic mode did we update the background colors to match worlds twill colors like we did
     on ai mode? If not we need to"): this product's background palette — World Emblem's 54 embroidered twill colours
     (embroidered and its SEO pages, 3D, Print & Stitch, Full Color) or its 14 stock chenille felts (no custom colour, and
     artwork colours offered as the nearest felt) — on the Patch Background Color row only; null = NP_CLASSIC_COLORS */
  var BG471 = window.NP_CLASSIC_BG471 || null;
  var BG471_KIND = BG471 && BG471.handles ? BG471.handles[HANDLE] || null : null;
  function bgPalette471(o) {
    if (!BG471_KIND || !isColorRow(o) || !/background/i.test(o.t || '')) return null;
    var list = BG471[BG471_KIND] || [];
    return list.length ? { list: list, stockOnly: BG471_KIND === 'chenille' } : null;
  }
  /* the nearest stock colour (CIELAB ΔE76, the pmsName distance) — np-emb2 stockNearest471 */
  function stockNearest471(hex, list) {
    var lab = hexToLab(hex), best = null, bd = Infinity;
    if (!lab) return null;
    (list || []).forEach(function (c) {
      var cl = c && c.h ? hexToLab(c.h) : null; if (!cl) return;
      var d = (lab[0] - cl[0]) * (lab[0] - cl[0]) + (lab[1] - cl[1]) * (lab[1] - cl[1]) + (lab[2] - cl[2]) * (lab[2] - cl[2]);
      if (d < bd) { bd = d; best = c; }
    });
    return best;
  }
  var artColors = [];
  var swExpanded = {}; /* per-option "Load more" expansion, survives re-renders */
  var swHideN = {};    /* per-option collapsed-swatch count — re-applied synchronously on re-render (no flash) */
  var SHAPE_ART = window.NP_CO_ASSETS || null; /* theme-hosted shape tile images */
  function tileImg(u) {
    /* data-file images may be bare theme-asset filenames (self-hosted mirror
       of the old app CDN) — resolve them against the shape assets' base URL */
    if (!u || /^(https?:)?\/\//.test(u) || /^data:/.test(u)) return u;
    var b = SHAPE_ART && SHAPE_ART.circle;
    return b ? b.replace(/[^\/]+$/, '') + u : '';
  }
  function shapeImg(valKey, orig) {
    if (!SHAPE_ART) return orig;
    var kS = String(valKey).toLowerCase();
    if (kS === 'custom shape') kS = 'custom';
    return SHAPE_ART[kS] || orig;
  }
  function cornerIcon(valKey) {
    var rx = /round/i.test(valKey) ? 16 : 2;
    var sv = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">' +
      '<rect x="9" y="9" width="46" height="46" rx="' + rx + '" fill="#F3FAF6" stroke="#131715" stroke-width="4"/></svg>';
    return 'data:image/svg+xml,' + encodeURIComponent(sv);
  }
  function artworkImg() {
    var im = document.getElementById('fileupload_hero') ||
      document.querySelector('.shopify-section[id$="__main"] .previewimg, .shopify-section[id$="__main"] .customDrop img');
    return (im && im.naturalWidth > 0 && /imgix|ninjauploads/i.test(im.src || '')) ? im : null;
  }
  function extractPalette() {
    var im = artworkImg();
    if (!im || artColors.length) return;
    try {
      var W = 72, H = Math.max(1, Math.round(im.naturalHeight * (W / im.naturalWidth)));
      var cv = document.createElement('canvas'); cv.width = W; cv.height = H;
      var probe = new Image(); probe.crossOrigin = 'anonymous';
      probe.onload = function () {
        try {
          var x = cv.getContext('2d'); x.drawImage(probe, 0, 0, W, H);
          var d = x.getImageData(0, 0, W, H).data, buckets = {};
          for (var i = 0; i < d.length; i += 4) {
            if (d[i + 3] < 128) continue;
            var k = (d[i] >> 4) + '.' + (d[i + 1] >> 4) + '.' + (d[i + 2] >> 4);
            (buckets[k] = buckets[k] || { n: 0, r: 0, g: 0, b: 0 });
            buckets[k].n++; buckets[k].r += d[i]; buckets[k].g += d[i + 1]; buckets[k].b += d[i + 2];
          }
          var tops = Object.keys(buckets).map(function (k2) { return buckets[k2]; })
            .sort(function (a, b2) { return b2.n - a.n; }).slice(0, 6);
          artColors = tops.filter(function (t) { return t.n > (W * H) * 0.01; }).map(function (t) {
            var hx = '#' + [t.r / t.n, t.g / t.n, t.b / t.n].map(function (v) {
              return ('0' + Math.round(v).toString(16)).slice(-2);
            }).join('');
            return hx.toUpperCase();
          });
          if (artColors.length) renderAll();
        } catch (eP2) {}
      };
      probe.src = im.src;
    } catch (eP) {}
  }
  var state = {}; /* title -> chosen value */
  var npLastShape = null; /* C469: the uploader re-runs the size when Select Shape changes (Circle/Square lock 1:1) */
  OPTS.forEach(function (o) { if (o.pre && o.vals.length) state[o.t] = matchPre(o); });
  function matchPre(o) {
    /* the app stored preselects loosely ("Heat Applied (Most Popular)") —
       match exact first, then prefix */
    var keys = o.vals.map(function (v) { return v.k; });
    if (keys.indexOf(o.pre) !== -1) return o.pre;
    for (var i = 0; i < keys.length; i++) {
      if (keys[i].indexOf(o.pre) === 0 || o.pre.indexOf(keys[i]) === 0) return keys[i];
    }
    return '';
  }

  function findForm() {
    return document.querySelector('.shopify-section[id$="__main"] form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]');
  }
  function visible(o) {
    /* a condition with an EMPTY value is inert in the app's admin — treat it
       as unconditional (embroidered's Border Thread Color carried one) */
    if (o.merged) return !!activeSub(o);
    if (!o.condT || !o.condV) return true;
    return (state[o.condT] || '') === o.condV;
  }
  /* C475/C476 (Justin 2026-10-07, = np-emb2 npNoVelcroFor): Full Color + an "Embroidered / Hot Cut" border OR Custom Shape = no Velcro backing;
     C492 (Justin 2026-10-13: "can we also turn off velcro for No border"): "No Border" too */
  var NO_VELCRO_HOTCUT = /^(sublimated-patches|sublimation-patches-for-hats)$/.test(HANDLE);
  /* C490 (Justin 2026-10-12, = np-emb2 npNoVelcroFor): Print & Stitch + a Merrow border = no Velcro backing */
  var NO_VELCRO_MERROW = /^(print-stitch-patches|print-and-stitch-patches)$/.test(HANDLE);
  /* C534 (Justin 2026-10-29, = np-emb2 npNoVelcroFor): 3D Embroidered + Custom Shape = no Velcro backing */
  var NO_VELCRO_CUSTOM = HANDLE === '3d-embroidered-patches';
  function borderNow() {
    var bv = '';
    RENDER.forEach(function (r) {
      if (bv || !visible(r)) return;
      var o = activeSub(r);
      if (o && /border style/i.test(r.merged ? r.base : o.t)) bv = state[o.t] || '';
    });
    return bv;
  }
  function valHidden(o, v) {
    /* C502 (Justin 2026-10-20, Full Color: "we need to remove hot cut as an embroidered option" / "heart shape and designs shape if selected we need to hide the merrow option") */
    if (NO_VELCRO_HOTCUT && /border style/i.test(o.t)) return /hot ?cut/i.test(v.k || '') || (/merrow/i.test(v.k || '') && /custom|heart/i.test(state['Select Shape'] || ''));
    if (!/backing/i.test(o.t) || !/velcro|hook/i.test(v.k || '')) return false;
    if (NO_VELCRO_MERROW) return /merrow/i.test(borderNow()); /* C490 */
    if (NO_VELCRO_CUSTOM) return /custom/i.test(state['Select Shape'] || ''); /* C534 */
    return NO_VELCRO_HOTCUT && (/hot ?cut|no border/i.test(borderNow()) || /custom/i.test(state['Select Shape'] || ''));
  }
  function dropHiddenPicks() {
    if (!NO_VELCRO_HOTCUT && !NO_VELCRO_MERROW && !NO_VELCRO_CUSTOM) return;
    OPTS.forEach(function (o) { if (state[o.t] && valHidden(o, { k: state[o.t] })) state[o.t] = ''; }); /* customer re-picks */
  }
  function neuterLegacyRequired() {
    /* THE SILENT DEAD-CHECKOUT: the theme's OLD hidden option fields
       (properties[_Select Shape] radios, properties[_Patch Background Color],
       …) keep their required attribute. Invisible + empty + required means
       native form validation cancels every submit with NO event and NO
       message — "Proceed to checkout does nothing". The `_` prefix already
       marks them as not-to-persist; they must never gate the submit either. */
    var f = findForm();
    if (!f) return;
    [].slice.call(f.querySelectorAll('[name^="properties[_"]')).forEach(function (el) {
      if (el.required && el.name !== 'properties[_Upload]') el.required = false;
    });
    /* and they must not SUBMIT either: a disabled input stays out of the
       POST, so orders stop carrying blank/duplicate `_Patch Background
       Color` / `_Select Your Backing` / `_Border Thread Color` mirrors of
       options this widget owns */
    OPTS.forEach(function (oL) {
      var tL = oL.t, tT = oL.t.replace(/\s+$/, '');
      [tL, tT].forEach(function (nm) {
        [].slice.call(f.querySelectorAll('[name="properties[_' + nm + ']"]')).forEach(function (el2) {
          el2.disabled = true;
        });
      });
    });
  }
  function syncProps() {
    var form = findForm();
    if (!form) return;
    neuterLegacyRequired();
    /* merged rows submit their CLEAN base name — "Border Style", not
       "Border Style Circle": the shape already rides as its own property,
       so the per-shape suffixes were pure duplication on the order */
    var want = {};
    RENDER.forEach(function (r) {
      if (!visible(r)) return;
      var o = activeSub(r);
      if (!o) return;
      var val = state[o.t] || '';
      if (!val) return;
      if (isColorRow(o)) val = withPmsHex(val); /* C491 */
      var nm = r.merged ? r.base : o.t;
      want['properties[' + nm + ']'] = val;
    });
    [].slice.call(form.querySelectorAll('input[data-np-co], textarea[data-np-co]')).forEach(function (inp) {
      if (!(inp.name in want)) inp.parentNode.removeChild(inp);
    });
    var npShapeNow = want['properties[Select Shape]'] || '';
    Object.keys(want).forEach(function (nm2) {
      var inp = null;
      var all = form.querySelectorAll('input[data-np-co]');
      for (var i = 0; i < all.length; i++) if (all[i].name === nm2) { inp = all[i]; break; }
      if (!inp) {
        inp = document.createElement('input');
        inp.type = 'hidden';
        inp.name = nm2;
        inp.setAttribute('data-np-co', '1');
        form.appendChild(inp);
      }
      inp.value = want[nm2];
    });
    if (npShapeNow !== npLastShape) { /* C469: fired AFTER the hidden field holds the new shape */
      npLastShape = npShapeNow;
      try { document.dispatchEvent(new CustomEvent('np:classic-shape', { detail: { shape: npShapeNow } })); } catch (eCs) {}
    }
  }
  function render(root) {
    dropHiddenPicks(); /* C475 */
    root.innerHTML = '';
    RENDER.forEach(function (r, n) {
      var o = activeSub(r) || (r.merged ? null : r);
      var row = document.createElement('div');
      row.className = 'np-co__row';
      row.setAttribute('data-np-co-row', String(n));
      if (!visible(r) || !o) { row.hidden = true; root.appendChild(row); return; }
      /* a sub that just became active gets its preselect applied once */
      if (o.pre && o.vals.length && state[o.t] === undefined) {
        var mp0 = matchPre(o);
        if (mp0) state[o.t] = mp0;
      }
      var labelTxt = (r.merged ? r.base : o.t).replace(/\s+$/, '');
      var lab = document.createElement('div');
      lab.className = 'np-co__lab';
      lab.innerHTML = escapeHtml(labelTxt) + (o.req ? '<span class="np-co__req">*</span>' : '');
      row.appendChild(lab);
      var isShapeRow = /shape/i.test(labelTxt) && !/corner/i.test(labelTxt);
      var isCornerRow = /corner style/i.test(labelTxt);
      var hasImgs = (o.k === 'img' && o.vals.some(function (v) { return !!v.i; })) || isCornerRow;
      if (o.k === 'pick' || o.k === 'img') {
        var pills = document.createElement('div');
        pills.className = hasImgs ? ('np-co__tiles' + (isShapeRow ? ' np-co__tiles--shape' : '')) : 'np-co__pills';
        o.vals.forEach(function (v) {
          if (valHidden(o, v)) return; /* C475 */
          var b = document.createElement('button');
          b.type = 'button';
          var on = (state[o.t] || '') === v.k;
          if (hasImgs) {
            var imSrc = isCornerRow ? cornerIcon(v.k) : (isShapeRow ? shapeImg(v.k, tileImg(v.i || '')) : tileImg(v.i || ''));
            /* "(Most Popular)" becomes a flag on the tile — the SUBMITTED value
               keeps the full app wording, only the caption is trimmed */
            var isMP = / \(Most Popular\)/i.test(v.k);
            var disp = v.k.replace(/ \(Most Popular\)/i, '');
            /* 2026-08-25 (Justin): "get rid of the Only option text in classic
               mode when its the only option its pretty self explanatory". Same
               contract as (Most Popular) above — the SUBMITTED value keeps the
               full app wording (production tooling parses these strings), only
               the caption is trimmed. */
            disp = disp.replace(/\s*\((?:the\s+)?only option[^)]*\)/i, '');
            if (/^Velcro \(Both Sides of Velcro Included\)$/i.test(disp)) disp = 'Velcro (Both sides)';
            b.className = 'np-co__tile' + (on ? ' is-on' : '');
            b.innerHTML = (isMP ? '<span class="np-co__flag">Most Popular</span>' : '') +
              (imSrc ? '<img loading="lazy" alt="" src="' + escapeHtml(imSrc) + '">' : '') +
              '<b>' + escapeHtml(disp) + '</b>';
          } else {
            b.className = 'np-co__pill' + (on ? ' is-on' : '');
            /* same trim on the non-image pills; stored value untouched */
            b.textContent = String(v.k).replace(/\s*\((?:the\s+)?only option[^)]*\)/i, '');
          }
          b.addEventListener('click', function () {
            state[o.t] = v.k;
            row.classList.remove('is-missing');
            renderAll(); /* conditionals may show/hide */
          });
          pills.appendChild(b);
        });
        row.appendChild(pills);
      } else if (o.k === 'text' && !o.ta && /color/i.test(o.t)) {
        /* color choice = the AI mode's swatches (artwork palette + standard
           colors + custom wheel); the property value stays a plain string
           (the PMS name), exactly what the old text field submitted */
        var cur = state[o.t] || '';
        var seenA = {}; /* one swatch per color NAME across artwork + standard */
        var pal471 = bgPalette471(o); /* C471: World Emblem's fabrics on this product's background */
        var STD = pal471 ? pal471.list : COLORS;
        /* Match My Artwork — the same flag + tooltip AI mode has, on EVERY
           color section; each section is one-or-the-other (MMA or a color) */
        if (true) {
          var isFol = cur === 'Match My Artwork';
          var folB = document.createElement('button');
          folB.type = 'button';
          folB.className = 'np-e2-lnc np-e2-lnc--follow' + (isFol ? ' is-on' : '');
          folB.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg>' +
            (isFol ? 'Match My Artwork \u2713' : 'Match My Artwork') +
            '<span class="np-e2-ftip" tabindex="0" aria-label="What does Match My Artwork do?"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg><span class="np-e2-ftip__pop"><img src="https://ninjauploads-production.imgix.net/np-follow-example-1786985124.png?w=520" alt="Example artwork with its own border and background" loading="lazy"><b class="np-e2-ftip__head">Image already designed correctly?</b><i>We will follow the background and border in your image to make sure your patch matches your design</i></span></span>';
          folB.addEventListener('click', function (evF) {
            if (evF.target.closest && evF.target.closest('.np-e2-ftip')) return;
            var onNow = (state[o.t] || '') === 'Match My Artwork';
            if (onNow) delete state[o.t]; else state[o.t] = 'Match My Artwork';
            renderAll();
          });
          row.appendChild(folB);
        }
        if (artColors.length) {
          var sub1 = document.createElement('div');
          sub1.className = 'np-co__subhead';
          sub1.textContent = 'COLORS FROM YOUR ARTWORK';
          row.appendChild(sub1);
          var artWrap = document.createElement('div');
          artWrap.className = 'np-co__sw';
          artColors.forEach(function (hx) {
            /* C471: a stock-only background (chenille) offers the artwork colour as its nearest stock felt */
            var stockA = pal471 && pal471.stockOnly ? stockNearest471(hx, STD) : null;
            var nameA = stockA ? stockA.l : pmsName(hx);
            if (seenA[nameA]) return; /* two near-identical artwork colors map to the same PMS — show it once */
            seenA[nameA] = 1;
            artWrap.appendChild(swatch(nameA, stockA ? stockA.h : (pmsHexOf(nameA) || hx), cur === nameA, row, o)); /* C491: the PMS's own colour */
          });
          row.appendChild(artWrap);
          var sub2 = document.createElement('div');
          sub2.className = 'np-co__subhead';
          sub2.textContent = 'STANDARD COLORS';
          row.appendChild(sub2);
        }
        var wrap = document.createElement('div');
        wrap.className = 'np-co__sw';
        STD.forEach(function (c) {
          if (seenA[c.l]) return; /* already offered under COLORS FROM YOUR ARTWORK */
          wrap.appendChild(swatch(c.l, c.h, cur === c.l, row, o));
        });
        /* custom wheel — named by nearest PMS, like AI mode (C471: none on a stock-only background) */
        var wheel = pal471 && pal471.stockOnly ? null : document.createElement('label');
        if (wheel) {
          wheel.className = 'np-co__swatch np-co__swatch--wheel';
          wheel.innerHTML = '<i></i><b>Custom</b><input type="color" value="#1AA86C">';
          wheel.querySelector('input').addEventListener('change', function () { renderAll(); });
          wheel.querySelector('input').addEventListener('input', function () {
            var nm = pmsName(this.value.toUpperCase());
            state[o.t] = nm;
            row.classList.remove('is-missing');
            wheel.querySelector('i').style.background = pmsHexOf(nm) || this.value; /* C491: the PMS's own colour */
            wheel.querySelector('b').textContent = nm;
            [].slice.call(row.querySelectorAll('.np-co__swatch')).forEach(function (x) { x.classList.toggle('is-on', x === wheel); });
            syncProps();
          });
          wrap.appendChild(wheel);
        }
        /* C491: a Custom pick (a PMS that is not an artwork or standard swatch) shows as its own chosen swatch, in the
           PMS's colour, first in the row — so the colour on screen is the one on the order */
        if (wheel && cur && isPmsLabel(cur) && !seenA[cur] && !STD.some(function (c) { return c.l === cur; })) wrap.insertBefore(swatch(cur, pmsHexOf(cur) || '#CCCCCC', true, row, o), wrap.firstChild);
        /* STANDARD COLORS collapse to 2 lines (Custom included) with a
           "+N more" tile — applies to background AND border color rows */
        var moreB = document.createElement('button');
        moreB.type = 'button';
        moreB.className = 'np-co__swatch np-co__more';
        moreB.innerHTML = '<i>\u22ef</i><b>More</b>';
        moreB.addEventListener('click', function () {
          swExpanded[o.t] = true;
          [].slice.call(wrap.children).forEach(function (ch) { ch.style.display = ''; });
          moreB.style.display = 'none';
        });
        wrap.appendChild(moreB);
        row.appendChild(wrap);
        var stdKids = function () {
          return [].slice.call(wrap.children).filter(function (ch) { return ch !== wheel && ch !== moreB; });
        };
        var applyMoreLabel = function () {
          var hidNow = stdKids().filter(function (ch) { return ch.style.display === 'none'; }).length;
          if (hidNow) { moreB.style.display = ''; moreB.querySelector('b').textContent = '+' + hidNow + ' more'; }
          else moreB.style.display = 'none';
        };
        if (swExpanded[o.t]) {
          moreB.style.display = 'none';
        } else if (swHideN[o.t]) {
          /* re-render (a shape/border change rebuilt the row): re-hide the
             remembered count SYNCHRONOUSLY so nothing flashes open */
          var skP = stdKids().filter(function (ch) { return !ch.classList.contains('is-on'); });
          for (var iP = skP.length - 1, nP = swHideN[o.t]; iP >= 0 && nP > 0; iP--, nP--) skP[iP].style.display = 'none';
          applyMoreLabel();
        }
        (function armCollapse(tries) {
          if (swExpanded[o.t]) return;
          setTimeout(function () {
            if (!wrap.isConnected || swExpanded[o.t]) return;
            function lineCount() {
              var tops = {};
              [].slice.call(wrap.children).forEach(function (ch) {
                if (ch.style.display === 'none') return;
                tops[Math.round(ch.offsetTop / 8)] = 1;
              });
              return Object.keys(tops).length;
            }
            /* not laid out yet (row still hidden) — retry until it is */
            if (wrap.offsetWidth === 0) { if (tries < 40) armCollapse(tries + 1); return; }
            /* phones fit far fewer swatches per line — allow 4 rows there */
            var maxLines = window.innerWidth <= 700 ? 4 : 2;
            var sk2 = stdKids().filter(function (ch) {
              return !ch.classList.contains('is-on') && ch.style.display !== 'none';
            });
            for (var iH = sk2.length - 1; iH >= 0 && lineCount() > maxLines; iH--) sk2[iH].style.display = 'none';
            swHideN[o.t] = stdKids().filter(function (ch) { return ch.style.display === 'none'; }).length;
            applyMoreLabel();
          }, tries ? 500 : 60);
        })(0);
      } else {
        var inp = document.createElement(o.ta ? 'textarea' : 'input');
        inp.className = 'np-co__txt';
        if (!o.ta) inp.type = 'text';
        inp.value = state[o.t] || '';
        inp.placeholder = o.req ? 'Required' : '';
        inp.addEventListener('input', function () {
          state[o.t] = this.value.trim();
          if (this.value.trim()) row.classList.remove('is-missing');
          syncProps();
        });
        row.appendChild(inp);
      }
      var err = document.createElement('span');
      err.className = 'np-co__err';
      err.textContent = 'Please choose ' + labelTxt.toLowerCase() + ' to continue.';
      row.appendChild(err);
      root.appendChild(row);
    });
    syncProps();
  }
  function escapeHtml(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }
  function swatch(label, hex, on, row, o) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'np-co__swatch' + (on ? ' is-on' : '');
    b.innerHTML = '<i style="background:' + hex + '"></i><b>' + escapeHtml(label) + '</b>';
    b.title = label;
    b.addEventListener('click', function () {
      state[o.t] = label;
      row.classList.remove('is-missing');
      /* full re-render: picking a color must also drop Match My Artwork's
         checked state (one or the other per section), and vice versa */
      renderAll();
    });
    return b;
  }

  var rootEl = null;
  function renderAll() { if (rootEl) render(rootEl); }

  function isShown(el) {
    /* rect + offsetParent is NOT enough: the theme keeps a ghost copy of the
       size widget laid out but visibility:hidden (post-upload it fooled the
       anchor pick and the options seated inside an invisible subtree). Walk
       the chain for display:none AND visibility:hidden. */
    if (!el) return false;
    var r = el.getBoundingClientRect();
    if (!(r.width > 0 || r.height > 0)) return false;
    var e = el;
    while (e && e !== document.documentElement) {
      var c;
      try { c = getComputedStyle(e); } catch (eV) { return false; }
      if (c.display === 'none' || c.visibility === 'hidden') return false;
      e = e.parentElement;
    }
    return true;
  }
  function uploadedUi() {
    /* the "Upload another patch?" box only renders once an upload landed —
       the safest post-upload marker across every classic product */
    var su = document.querySelector('.shopify-section[id$="__main"] .second-upload-cta') ||
      document.querySelector('.second-upload-cta');
    return !!(su && isShown(su));
  }
  function pickAnchor() {
    /* the section renders SEVERAL size widgets (pre/post-upload copies, plus
       a laid-out-but-invisible ghost) — the options must sit above the one
       the customer can actually SEE. Pre-upload nothing qualifies: return
       null and stay off the page. */
    var cands = [].slice.call(document.querySelectorAll(
      '.shopify-section[id$="__main"] .customVariantWidget, .shopify-section[id$="__main"] .customVariantWidget-2'));
    for (var i = 0; i < cands.length; i++) if (isShown(cands[i])) return cands[i];
    if (!uploadedUi()) return null;
    /* post-upload with no visible size widget: seat as a SIBLING above the
       buttons row — anchoring on the ATC button itself buried the options
       INSIDE .cta-wrapper-box (nested in the checkout button's wrapper) */
    var fbA = document.querySelector('.shopify-section[id$="__main"] .second-upload-cta');
    var fbRowA = fbA ? (fbA.closest('.flex-buttons') || fbA) : null;
    if (fbRowA && isShown(fbRowA)) return fbRowA;
    var atc = document.querySelector('.shopify-section[id$="__main"] button.add-to-cart') ||
      document.querySelector('button.add-to-cart');
    return isShown(atc) ? atc : null;
  }
  function ensureRoot() {
    if (!rootEl) {
      rootEl = document.createElement('div');
      rootEl.id = 'np-co';
      rootEl.className = 'np-co';
      render(rootEl);
      wireValidation();
    } else if (!document.getElementById('np-co')) {
      render(rootEl);
    }
    return rootEl;
  }
  function seat() {
    var a2 = pickAnchor();
    if (!a2 || !a2.parentNode) return;
    ensureRoot();
    /* the "Patch Size" strip belongs UNDER the size widget as one card — the
       options seat AFTER the strip, never between the widget and it */
    if (/(^|\s)customVariantWidget-2(\s|$)/.test(a2.className || '')) {
      if (rootEl.previousElementSibling !== a2) a2.parentNode.insertBefore(rootEl, a2.nextSibling);
      setTimeout(function () {
        if (document.getElementById('np-co') && !isShown(rootEl) && isShown(a2)) {
          mount.__climb = Math.min((mount.__climb || 0) + 1, 5);
        }
      }, 250);
      return;
    }
    /* seat before the anchor; if a CSS trap (tabbed size UI hides extra
       children, hidden wrapper) keeps the options invisible while the
       anchor IS visible, climb one ancestor per tick until they show */
    var tgt = a2;
    for (var lv = 0; lv < (mount.__climb || 0); lv++) {
      var pUp = tgt.parentElement;
      if (!pUp || pUp === document.body || /shopify-section/.test(pUp.className || '')) break;
      tgt = pUp;
    }
    if (!tgt.parentNode) return;
    if (rootEl.nextElementSibling !== tgt) tgt.parentNode.insertBefore(rootEl, tgt);
    setTimeout(function () {
      if (document.getElementById('np-co') && !isShown(rootEl) && isShown(a2)) {
        mount.__climb = Math.min((mount.__climb || 0) + 1, 5);
      }
    }, 250);
  }
  function pinBottom() {
    /* wanted page order: sizing card → OPTIONS → proof card → "upload
       another" box → checkout. The legacy DOM keeps the upload row above
       where the options seat — move it (and the proof card with it) below. */
    if (!rootEl || !rootEl.parentNode || !isShown(rootEl)) return;
    var sec = document.querySelector('.shopify-section[id$="__main"]') || document;
    var fb = sec.querySelector('.second-upload-cta');
    var fbRow = fb ? (fb.closest('.flex-buttons') || fb) : null;
    if (!fbRow || !fbRow.parentNode) return;
    if (fbRow.contains(rootEl)) {
      /* seated INSIDE the buttons row (old ATC-button fallback) — hoist the
         options out to sit ABOVE the row; moving the row into its own
         descendant's parent throws, which silently killed this fix before */
      fbRow.parentNode.insertBefore(rootEl, fbRow);
    } else if (rootEl.compareDocumentPosition(fbRow) & Node.DOCUMENT_POSITION_PRECEDING) {
      rootEl.parentNode.insertBefore(fbRow, rootEl.nextSibling);
    }
    var cst = document.getElementById('np-cst');
    if (cst && cst.nextElementSibling !== fbRow) {
      fbRow.parentNode.insertBefore(cst, fbRow);
    }
  }
  function mount() {
    mount.__climb = mount.__climb || 0;
    /* KEEP-ALIVE: the legacy uploader re-renders this area after the upload
       lands, and the visible size widget is a different node pre/post upload
       — keep trying until the options are genuinely on screen, then watch. */
    if (!mount.__tick) {
      mount.__tick = setInterval(function () {
        extractPalette();
        neuterLegacyRequired();
        /* keep both exits visually locked while anything required is unpicked
           (the proof card counts too, when the product has one) */
        if (rootEl) {
          var lockNow = missingReq().length > 0 ||
            (document.getElementById('np-cst') && !document.querySelector('#np-cst [data-cst].is-on'));
          ['button.add-to-cart', '.second-upload-cta'].forEach(function (selL) {
            var scB = document.querySelector('.shopify-section[id$="__main"] ' + selL) || document.querySelector(selL);
            if (scB) scB.classList.toggle('np-e2-atc-locked', !!lockNow);
          });
          /* the LEGACY validation layer never sees this widget's inputs, so
             its .disabled-cta wrapper kept eating clicks even after our lock
             cleared — mirror its activation classes both ways (but never
             re-enable mid second-upload processing) */
          var busyP = window.__npSecondUploadInProgress || document.body.classList.contains('processing-second-upload');
          if (!lockNow && !busyP) {
            var wrapC = document.querySelector('.cta-wrapper-box');
            if (wrapC) wrapC.classList.add('validated');
            [].slice.call(document.querySelectorAll('.disabled-cta')).forEach(function (d) { d.classList.add('active'); });
            [].slice.call(document.querySelectorAll('.disabled-cta .add-to-cart, .second-upload-cta, .anotherTransfer')).forEach(function (b) { b.classList.remove('disabled'); });
          } else if (lockNow) {
            [].slice.call(document.querySelectorAll('.disabled-cta')).forEach(function (d) { d.classList.remove('active'); });
          }
        }
        if (document.getElementById('np-co') && rootEl && isShown(rootEl)) { pinBottom(); return; }
        seat();
        pinBottom();
      }, 900);
    }
    seat();
    pinBottom();
  }

  function missingReq() {
    var arr = [];
    RENDER.forEach(function (r, n) {
      if (!visible(r)) return;
      var o = activeSub(r);
      if (!o || !o.req) return;
      if (!(state[o.t] || '').trim()) arr.push(n);
    });
    return arr;
  }
  function focusMissing(missing) {
    if (!rootEl) return;
    RENDER.forEach(function (r, n) {
      var row = rootEl.querySelector('[data-np-co-row="' + n + '"]');
      if (row) row.classList.toggle('is-missing', missing.indexOf(n) !== -1);
    });
    var first = rootEl.querySelector('.is-missing');
    if (first) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  /* shared with np-emb2's proof card so both gates agree on "complete" */
  window.NP_CO_MISSING = function () { return rootEl ? missingReq().length : 0; };
  window.NP_CO_FOCUS = function () { if (rootEl) focusMissing(missingReq()); };
  function wireValidation() {
    /* required options gate BOTH exits — Add to Cart AND "Upload another
       patch" — at click time in the CAPTURE phase: nothing loads, the page
       scrolls to the first section still needing a choice */
    document.addEventListener('click', function (ev) {
      var btn = ev.target.closest && ev.target.closest('button.add-to-cart, .second-upload-cta');
      if (!btn || !rootEl) return;
      if (!ev.isTrusted) { syncProps(); return; } /* theme pipeline click — mirror props, never block */
      var missing = missingReq();
      if (!missing.length) { syncProps(); return; }
      ev.preventDefault();
      ev.stopImmediatePropagation();
      focusMissing(missing);
    }, true);
  }

  function boot() {
    var hasBuilder = !!document.querySelector('#np-e2, .np-e2');
    if (!hasBuilder) { mount(); return; }
    /* 2.0 page: this widget belongs to CLASSIC mode only */
    if (document.body.classList.contains('np-e2-classic')) { mount(); return; }
    new MutationObserver(function (_m, obs) {
      if (document.body.classList.contains('np-e2-classic')) { mount(); obs.disconnect(); }
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
